import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Lightbulb, X } from "@phosphor-icons/react";

export const NotesCard = () => {
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    api.get("/notes").then((r) => setNotes(r.data.notes)).catch(() => {});
  }, []);

  const remove = async (id) => {
    setNotes((n) => n.filter((x) => x.id !== id));
    try { await api.delete(`/notes/${id}`); } catch {}
  };

  if (!notes.length) return null;

  return (
    <div className="glass-card p-5 mb-6" data-testid="notes-card">
      <div className="flex items-center gap-2 mb-3">
        <Lightbulb size={20} weight="duotone" className="text-amber-300" />
        <h2 className="font-heading font-semibold">Мысли</h2>
        <span className="text-xs text-muted-foreground">— надиктовано с очков</span>
      </div>
      <div className="space-y-2.5">
        {notes.slice(0, 5).map((n) => (
          <div key={n.id} className="flex items-start gap-2 group" data-testid="note-item">
            <div className="flex-1 min-w-0">
              <p className="text-sm leading-relaxed">{n.text}</p>
              <div className="flex items-center gap-1.5 mt-0.5 flex-wrap">
                {n.tags.map((t, i) => (
                  <span key={i} className="text-[10px] font-semibold text-primary/80">#{t}</span>
                ))}
                <span className="text-[10px] text-muted-foreground">
                  {new Date(n.created_at).toLocaleString("ru-RU", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}
                </span>
              </div>
            </div>
            <button onClick={() => remove(n.id)} data-testid="note-delete-btn"
              className="p-1 text-muted-foreground opacity-0 group-hover:opacity-100 hover:text-red-400 transition-all shrink-0">
              <X size={13} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
